import { Field, NumericInput, TextOutput } from 'Components/Core';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetBalanceFieldSet, WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';

let BsMeasurementsSection: React.FC<IWorksheetComponent> = () => {
  return (
    <>
      <ListFieldSection heading="Room Conditions">
        <Field input={<WorksheetEquipmentDropdown />} equipmentType="thermometer" name="Equipment.RoomThermometer" />
        <Field input={<NumericInput />} name="Measurements.MinimumRoomTemperature" />
        <Field input={<NumericInput />} name="Measurements.MaximumRoomTemperature" />
        <Field input={<TextOutput />} name="Measurements.RoomTemperatureRange" />
      </ListFieldSection>

      <ListFieldSection heading="Particle Density Determination">
        <WorksheetBalanceFieldSet name="Equipment.MeasurementBalance" />
        <Field input={<WorksheetEquipmentDropdown />} equipmentType="thermometer" name="Equipment.TestThermometer" />
        <Field input={<WorksheetEquipmentDropdown />} equipmentType="timer" name="Equipment.Clock" />
        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="mechanical-shaker"
          name="Equipment.MechanicalShaker"
        />
      </ListFieldSection>
    </>
  );
};

BsMeasurementsSection = withInjectedProps(BsMeasurementsSection);

export { BsMeasurementsSection };
export default BsMeasurementsSection;
